<template>
  <tr class="group contents">
    <slot />
  </tr>
</template>
